import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../components';
import StackedBarChart from '../../charts/StackedBarChart';
import DevicePerSdkVersion from './version/DevicePerSdkVersion';
import DevicePerOsVersion from './version/DevicePerOsVersion';
import DevicePerSdkVersionEvolution from './version/DevicePerSdkVersionEvolution';
import DevicePerOsVersionEvolution from './version/DevicePerOsVersionEvolution';
import { globalLocationStatusDataToChartData, locationStatusDataToChartData } from '../../../services/data/charts/locationStatusDataToCharData';
import { useGetAppAdminLocationStatusPerOsVersionQuery } from '../../../api/appAdminApiSlice';
import Block from '../../Block';

const LocationStatusPerOsVersion = ({appId}) => {
  const { t } = useTranslation();
  const { data=[], isSuccess, isError, retry } = useGetAppAdminLocationStatusPerOsVersionQuery(appId)
  const chartData = globalLocationStatusDataToChartData(data)

  return (
    <Block title={t('version.location_status_per_os_version')}>
      <Loader success={true} error={false} minHeight={"100%"}>
        <StackedBarChart data={chartData} />
      </Loader>
    </Block>
  )
}

const Version = ({appId}) => {
  return (
    <>
      <Row>
        <DevicePerSdkVersion appId={appId} as={Col} md={4}/>
        <DevicePerSdkVersionEvolution appId={appId} as={Col} md={8}/>
      </Row>
      <Row>
        <DevicePerOsVersion appId={appId} as={Col} md={4}/>
        <DevicePerOsVersionEvolution appId={appId} as={Col} md={8}/>
      </Row>
      <LocationStatusPerOsVersion appId={appId}/>
    </>
  )
}

export default Version
